export var EciStatusCode;
(function (EciStatusCode) {
    EciStatusCode[EciStatusCode["Ok"] = 0] = "Ok";
    EciStatusCode[EciStatusCode["ProtocolError"] = 252] = "ProtocolError";
    EciStatusCode[EciStatusCode["PluginNotFound"] = 253] = "PluginNotFound";
    EciStatusCode[EciStatusCode["Timeout"] = 254] = "Timeout";
    EciStatusCode[EciStatusCode["GenericError"] = 255] = "GenericError";
})(EciStatusCode || (EciStatusCode = {}));
